import React from 'react';
import { Row, Col, Image, Space, Typography, Card, Grid } from 'antd';
import Img1 from '../../assets/img/speaker1.png';
import Img2 from '../../assets/img/speaker2.png';
import Img3 from '../../assets/img/speaker3.png';
import Img4 from '../../assets/img/speaker4.png';
import Img5 from '../../assets/img/speaker5.png';
import './Home.css';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Speakers() {
  const { xs, xxl } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row justify="space-around" align="middle" gutter={[0,16]} style={{ backgroundColor: '#F2F2F2', padding: 16, textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Speakers</Text>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img1}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 -10px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?user=qDjUGgkAAAAJ&hl=id&oi=ao" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Asc. Prof. Theo Bodin</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Karolinska Institute, Swedish)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Reducing Negatives Effect of Precarious Employment in Developing Countries"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img2}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?user=qgS36BsAAAAJ&hl=id&oi=ao" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Prof. Vidhya Venugopal</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Sri Ramachandra Institute, India)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"The Effect of Air Pollution on Public Health and Social Life"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img3}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=7psN6ZgAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Prof. Erwin Faller</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Holy Child Central Colleges Inc, Philippines)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Current Issue in Tourism: Lessons Learned From Pandemic Diseases Preparedness"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img4}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 -20px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=6pRs-RwAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>dr. Anna Suraya, Ph.D</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Universitas Binawan, Indonesia)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Protect People From Asbestos Exposure During Disaster"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={24}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img5}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=129b7MEAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Dr. Ir. Yaya Suryana, M.Eng., IPU*</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Indonesia Artificial Intelligence Society, Indonesia)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"AI in Public Health"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
          </Row>
        :
          <Row justify="space-around" align="middle" gutter={[64,64]} style={{ backgroundColor: '#F2F2F2', padding: xxl ? '50px 300px 70px 300px' : '50px 50px 70px 50px', textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 30, fontWeight: 'bold' }}>Speakers</Text>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img1}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 -10px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?user=qDjUGgkAAAAJ&hl=id&oi=ao" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Asc. Prof. Theo Bodin</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Karolinska Institute, Swedish)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Reducing Negatives Effect of Precarious Employment in Developing Countries"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img2}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?user=qgS36BsAAAAJ&hl=id&oi=ao" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Prof. Vidhya Venugopal</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Sri Ramachandra Institute, India)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"The Effect of Air Pollution on Public Health and Social Life"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img3}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=7psN6ZgAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Prof. Erwin Faller</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Holy Child Central Colleges Inc, Philippines)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Current Issue in Tourism: Lessons Learned From Pandemic Diseases Preparedness"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={4}></Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img4}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 -20px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=6pRs-RwAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>dr. Anna Suraya, Ph.D</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Universitas Binawan, Indonesia)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"Protect People From Asbestos Exposure During Disaster"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ width: '100%', height: 380, paddingTop: 32, borderRadius: 8, boxShadow: '0 8px 12px 4px #E8E8E8' }}>
                <Space direction='vertical' size={16} align='center'>
                  <Image
                    width={150}
                    height={150}
                    src={Img5}
                    preview={false}
                    style={{ objectFit: 'cover', objectPosition: '0 5px', borderRadius: 100, backgroundColor: '#F2F2F2' }}
                  />
                  <Space direction='vertical' size={0} align='center'>
                    <a href="https://scholar.google.com/citations?hl=id&user=129b7MEAAAAJ" target="_blank" rel="noreferrer">
                      <Text className='link-name' strong style={{ fontSize: 15 }}>Dr. Ir. Yaya Suryana, M.Eng., IPU*</Text>
                    </a>
                    <Text style={{ fontSize: 15 }}>(Indonesia Artificial Intelligence Society, Indonesia)</Text>
                    <Text type='secondary' style={{ fontSize: 13 }}>"AI in Public Health"</Text>
                  </Space>
                </Space>
              </Card>
            </Col>
            <Col span={4}></Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Speakers